import React from 'react';
import { Link } from 'react-router-dom';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import { listIntegrations } from './integrations';
import { Footer } from '../homepage/Footer';
import '../pages/static-page.css';

export const IntegrationsIndexPage: React.FC = () => {
  const integrations = listIntegrations();
  const byCategory = {
    web: integrations.filter(i => i.module.frontmatter.category === 'web'),
    mobile: integrations.filter(i => i.module.frontmatter.category === 'mobile'),
    backend: integrations.filter(i => i.module.frontmatter.category === 'backend'),
  };

  return (
    <>
      <PageSeo
        path="/integrations"
        titleKey="seo.integrations.title"
        descriptionKey="seo.integrations.description"
        ogImage="/og/og-default.png"
        keywords={[
          'react localization', 'nextjs i18n', 'vue translation',
          'angular i18n', 'svelte localization', 'flutter i18n',
          'django translation', 'rails i18n',
        ]}
        jsonLd={[
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Integrations', path: '/integrations' },
          ]),
        ]}
      />
      <div className="page-wrapper">
        <div className="static-page" style={{ paddingTop: '40px' }}>
          <h1>Integrations</h1>
          <p style={{ fontSize: 18, color: '#555', maxWidth: 720 }}>
            Localingos works with every major web, mobile, and backend framework.
            Pick yours below for a step-by-step integration guide.
          </p>

          {(['web', 'mobile', 'backend'] as const).map(cat => byCategory[cat].length > 0 && (
            <section key={cat} style={{ marginTop: 40 }}>
              <h2 style={{ textTransform: 'capitalize', marginBottom: 16 }}>{cat}</h2>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
                gap: 16,
              }}>
                {byCategory[cat].map(i => (
                  <Link
                    key={i.slug}
                    to={`/integrations/${i.slug}`}
                    style={{
                      display: 'block',
                      padding: 20,
                      border: '1px solid #e5e7eb',
                      borderRadius: 8,
                      textDecoration: 'none',
                      color: 'inherit',
                      transition: 'border-color 0.15s, transform 0.15s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = '#2563EB'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = '#e5e7eb'; }}
                  >
                    <h3 style={{ margin: '0 0 8px', fontSize: 18 }}>
                      {i.module.frontmatter.framework}
                    </h3>
                    <p style={{ margin: 0, color: '#666', fontSize: 14, lineHeight: 1.4 }}>
                      {i.module.frontmatter.description}
                    </p>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
        <Footer />
      </div>
    </>
  );
};
